import { useCallback, useEffect, useRef, useState } from 'react'

export function useResendTimeout(delay = 10000) {
  const intervalRef = useRef<NodeJS.Timeout>()

  const [isResendDisabled, setIsResendDisabled] = useState(true)
  const [countdown, setCountdown] = useState(delay / 1000) // Initialisation avec la durée en secondes

  const setResendTimeout = useCallback(() => {
    setIsResendDisabled(true)
    setCountdown(delay / 1000) // Réinitialisation du décompte
    clearInterval(intervalRef.current)

    // Déclenche le décompte
    intervalRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(intervalRef.current)
          setIsResendDisabled(false)
          return 0
        }
        return prev - 1
      })
    }, 1000)
  }, [delay])

  useEffect(() => {
    // Démarre le décompte initial
    setResendTimeout()
    return () => {
      clearInterval(intervalRef.current)
    }
  }, [setResendTimeout])

  return {
    isResendDisabled,
    countdown, // Ajout du décompte dans le retour
    setResendTimeout,
  }
}
